module.exports = __webpack_public_path__ + "media/images/pix/pix-logo-6d1c38bcc4e915856a525cb1da0ee1cd.png";